import React from 'react';

import Button from '../../atoms/player/button/Button';
import Duration from '../../atoms/player/duration/Duration';
import { IconStatus } from '../../../typings/design-tokens';
import styles from '../../../utils/styles';

import './PosterPlayer.scss';

export interface IPosterPlayer {
  duration?: string | number;
  videoStill?: string;
  altImage?: string;
  onClick?: any;
  isHidden: boolean;
  playButtonState?: IconStatus;
  title?: string;
}

const PosterPlayer: React.FC<IPosterPlayer> = ({
  duration,
  videoStill,
  altImage,
  onClick,
  isHidden,
  playButtonState,
  title,
}) => {
  const className = styles(
    'poster-player',
    playButtonState !== 'disabled' && 'poster-player--pointer',
    isHidden && 'poster-player--hidden'
  );

  return (
    <button type="button" aria-label={title} className={className} onClick={onClick}>
      <Button className={styles('poster-player__button')} status={playButtonState} />
      {duration && <Duration className={styles('poster-player__duration')} value={String(duration)} />}
      <img className={styles('poster-player__preview')} src={videoStill} alt={altImage} />
    </button>
  );
};

export default PosterPlayer;
